import { render, staticRenderFns } from "./tuidang.vue?vue&type=template&id=392bd8bf&scoped=true"
import script from "./tuidang.vue?vue&type=script&lang=js"
export * from "./tuidang.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/.store/vue-loader@15.11.1/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "392bd8bf",
  null
  
)

export default component.exports